<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      createButtonText="新建价格规则"
      resource="pricing_rules"
    />
  </div>
</template>


<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class PricingRules extends Vue {

  table = { data: [] }
  pagination = {}

  filter = [
    {
      prop: 'goods_sku_id_eq',
      label: 'sku id等于',
      form: {
        component: 'input',
        props: {
          placeholder: '请输入关键字'
        }
      }
    }
  ]

  get columns() {
    return [
      ...createColumns.call(this),
      {
        prop: 'action',
        label: '操作',
        fixed: 'right',
        width: 140,
        detail: true,
        edit: true,
        delete: {
          handler: this.handleDelete
        }
      }
    ]
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/pricing_rules', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }

  async handleDelete({ row }) {
    await this.$request.delete(`/pricing_rules/${row.id}`);
    this.fetchData();
  }
}
</script>
